import styled from "styled-components";

export const DynamicRefereeFieldsContainer = styled.div`
  margin: 8px 0;
`;
